import { Observable } from '../lib/store';

/**
 * UI selection of the Sync workspace (Phase 4A): which session, reaction, event, marker
 * and motion cue are selected. Prompts read it as explicit context ("the selected
 * reaction"). Not project data: never saved and never recorded in undo history.
 */
export interface SyncSelectionState {
  sessionId: string | null;
  mappingId: string | null;
  /** Selected extracted or manual event (its stable event id). */
  eventId: string | null;
  cueId: string | null;
}

export const EMPTY_SYNC_SELECTION: SyncSelectionState = { sessionId: null, mappingId: null, eventId: null, cueId: null };

export class SyncSelectionStore extends Observable<SyncSelectionState> {
  constructor() {
    super(EMPTY_SYNC_SELECTION);
  }

  selectSession(sessionId: string | null): void {
    if (sessionId === this.get().sessionId) return;
    this.set({ ...EMPTY_SYNC_SELECTION, sessionId });
  }

  clear(): void {
    this.set(EMPTY_SYNC_SELECTION);
  }
}
